import React, { Component } from 'react'
import PropTypes from 'prop-types'

import extend from 'extend'

const defaultOptions = {
    initialSortFieldName: 'name',
    initialSortDirection: 1
}

export default function withDataTable(ChildComponent, options) {

    options = Object.assign({}, defaultOptions, options)

    class WithDataTableWrapper extends Component {

        static propTypes = {
            data: PropTypes.array.isRequired,
            dataPage: PropTypes.number.isRequired,
            initialSortDirection: PropTypes.number,
            initialSortFieldName: PropTypes.string,
            isDataFetching: PropTypes.bool,
            isSearchFetching: PropTypes.bool,
            metadata: PropTypes.object,
            onFilter: PropTypes.func,
            onPaging: PropTypes.func,
            onSearch: PropTypes.func,
            onSearchTextChange: PropTypes.func,
            onSorting: PropTypes.func,
            onUpdateData: PropTypes.func.isRequired,
            onUpdateSearchSuggestion: PropTypes.func,
            pageSize: PropTypes.number,
            searchSuggestion: PropTypes.arrayOf(PropTypes.string).isRequired,
            totalItems: PropTypes.number,
        }

        static defaultProps = {
            initialSortFieldName: options.initialSortFieldName,
            initialSortDirection: options.initialSortDirection,
            pageSize: options.pageSize,
            totalItems: 0
        }

        constructor(props) {
            super(props)

            this.state = {
                sorting: [
                    { key: props.initialSortFieldName, value: props.initialSortDirection }
                ],
                page: 0,
                query: '',
                queryHistory: [],
                filterData: {}
            }

            this._internalInvokePropsMethod = this._internalInvokePropsMethod.bind(this)

            this.handleFilter = this.handleFilter.bind(this)
            this.handlePaging = this.handlePaging.bind(this)
            this.handleSearch = this.handleSearch.bind(this)
            this.handleSearchTextChange = this.handleSearchTextChange.bind(this)
            this.handleSorting = this.handleSorting.bind(this)
        }

        _internalInvokePropsMethod(methodName, ...arg) {
            const fn = this.props[methodName]

            if (!fn) {
                return
            }

            const newState = fn(...arg, this.state, this.props)

            if (newState !== undefined) {
                this.setState(newState)
            }
        }

        handlePaging(value) {
            this.setState({ page: value }, () => {
                this._internalInvokePropsMethod('onUpdateData')
            })
        }

        handleSorting(sorting) {
            this.setState({ sorting }, () => {
                this._internalInvokePropsMethod('onUpdateData')
            })
        }

        handleFilter(filterData, sortingValue = []) {
            let { sorting } = this.state
            const { page } = this.state
            sorting = sortingValue.length ? sortingValue : sorting
            //shouldUseCurrentPage decides whether the current page should be used in the request or the first page.Currently used in audience-grid-content.OSP-8639
            const shouldUseCurrentPage = filterData.shouldUseCurrentPage
            delete filterData.shouldUseCurrentPage
            
            this.setState({ filterData, page: shouldUseCurrentPage ? page : 0, sorting }, () => {
            this._internalInvokePropsMethod('onUpdateData')
            })
        }

        handleSearch(query, queryHistory) {
            this.setState({ query, queryHistory, page: 0 }, () => {
                this._internalInvokePropsMethod('onSearchTextChange', query)
                this._internalInvokePropsMethod('onUpdateData')
            })
        }

        handleSearchTextChange(query) {
            this._internalInvokePropsMethod('onSearchTextChange', query)
        }

        render() {
            const {
                data,
                dataPage,
                isDataFetching,
                isSearchFetching,
                metadata,
                pageSize,
                searchSuggestion,
                totalItems
            } = this.props
            const { query, queryHistory, sorting } = this.state
            const newProps = {
                searchBoxProps: {
                    isFetching: isSearchFetching,
                    onChange: this.handleSearchTextChange,
                    onSearch: this.handleSearch,
                    query,
                    queryHistory,
                    searchSuggestion
                },
                filterProps: {
                    onFilter: this.handleFilter,
                    metadata
                },
                tableProps: {
                    data,
                    isDataFetching,
                    onSorting: this.handleSorting,
                    searchQuery: query,
                    sorting: sorting
                },
                paginationProps: {
                    isDataFetching,
                    onPaging: this.handlePaging,
                    page: dataPage,
                    pageSize,
                    totalItems,
                }
            }

            const updatedProps = extend(true, newProps, options.props)

            return <ChildComponent {...updatedProps} />
        }
    }

    return WithDataTableWrapper
}



// WEBPACK FOOTER //
// src/containers/high-order-components/with-data-table.js